module.exports = __webpack_public_path__ + "img/kurir-hanging.8ce84883.svg";